import React from 'react';
import { useLocation } from 'react-router-dom';
import { parse } from 'query-string';
import { useRecoilValue } from 'recoil';

import { applicationInfoQuery } from '../../features/application';
import { Approval } from './Approval';
import { Consent } from './Consent';
import { Authorize } from './Authorize';
import { LoadingScreen } from '../../components/LoadingScreen';

export function AuthorizeEntrance() {
	const { search } = useLocation();
	const { provider_id } = parse(search) as any;
	const provider = useRecoilValue(applicationInfoQuery(provider_id));
	const { approve_uri, consent_uri } = provider;

	return (
		<>
			{approve_uri ? (
				<Approval approve_uri={approve_uri} consent_uri={consent_uri} />
			) : consent_uri ? (
				<Consent consent_uri={consent_uri} />
			) : (
				<Authorize />
			)}
			<LoadingScreen />
		</>
	);
}
